<header [ngClass]="{'menu-opened': isOpened}">
  <div class="header-wrapper-content">
    <div class="logo-container">
      <img class="white" src="../assets/images/logos/cpa-logo-white.png" alt="">
    </div>

    <div class="menu-container">
      <button class="nav-btn" [ngClass]="{'open': isOpened}" (click)="isOpened = !isOpened">
        <i></i><i></i><i></i>
      </button>
      <ul class="nav" data-aos="fade-up" data-aos-delay="200">
        <li>
          <a [routerLink]="['/']" routerLinkActive="active">
            {{'header.Home' | translate}}
          </a>
        </li>
        <li>
          <a href="#">
            {{'header.Association' | translate}}
          </a>
        </li>
        <li>
          <a href="#">
            {{'header.Programs and activities' | translate}}
          </a>
        </li>
        <li>
          <a href="#">
            {{'header.Media Center' | translate}}
          </a>
        </li>
        <li>
          <a href="#">
            {{'header.Contact us' | translate}}
          </a>
        </li>
        <li>
          <a href="#">
            {{'header.Training courses' | translate}}
          </a>
        </li>
      </ul>
      <div class="icon search">
        <input type="text" name="search" [placeholder]="'header.search' | translate">
      </div>
      <div class="elementor-widget-container" *ngIf="currentUser">
        <div class="notification-btn dropdown-container" appDropDown>
          <span (click)="openNotificationPanel()">
            <span class="notification-count">{{ notificationsResult.unSeenNotificationsCount }}</span>
            <img src="./assets/images/icons/notifications-icon.svg"
              [ngClass]="{swing: notificationsResult.unSeenNotificationsCount}">
          </span>
          <div class="notification-panel dropdown-inner-menu">
            <div class="notification-header">
              <h3>{{ 'general.Notification' | translate }}</h3>
            </div>

            <div class="notifications-wrapper">
              <div *ngIf='notifLoading' class="dataLoading py-5">
                <mat-spinner class="m-auto" diameter="50"></mat-spinner>
              </div>
              <ng-container *ngIf="!notifLoading">
                <div class="no-data text-center d-flex align-items-center justify-content-center h-100 px-2 py-5"
                  *ngIf="!notificationsList.length">
                  {{ 'general.You have no notifications' | translate }}!
                </div>
                <div *ngIf="notificationsList.length">
                  <div class="notification-list" infiniteScroll [scrollWindow]="false" [infiniteScrollDistance]="2"
                    [infiniteScrollThrottle]="pageCount" (scrolled)="getNextPage()">
                    <div *ngFor="let notif of notificationsList" [ngClass]="notif.isSeen ? '':'new'"
                      (click)="seeNotifications(notif)">
                      <ng-container [ngSwitch]="notif?.notificationType">
                        <!-- <a *ngSwitchCase="'NEW_RIGHT_FOR_REVIEW'"
                          [routerLink]="['/admin/rights/details' , notif.objectId]">
                          <ng-container [ngTemplateOutlet]="notifContent"
                            [ngTemplateOutletContext]='{notif}'></ng-container>
                        </a>
                        <a *ngSwitchCase="'RIGHT_UPDATED'" [routerLink]="['/admin/rights/details' , notif.objectId]">
                          <ng-container [ngTemplateOutlet]="notifContent"
                            [ngTemplateOutletContext]='{notif}'></ng-container>
                        </a> -->

                        <a *ngSwitchCase="'TICKET_UPDATED'"  [routerLink]="['/complaints/details' , notif.objectId]">
                          <ng-container [ngTemplateOutlet]="notifContent" [ngTemplateOutletContext]='{notif}'></ng-container>
                        </a>

                        <a *ngSwitchDefault>
                          <ng-container [ngTemplateOutlet]="notifContent"
                            [ngTemplateOutletContext]='{notif}'></ng-container>
                        </a>
                      </ng-container>
                    </div>
                  </div>
                  <!-- <cdk-virtual-scroll-viewport class="notification-list" [itemSize]="10" (scrolledIndexChange)="getNextPage($event)">
                          <div *cdkVirtualFor="let notif of notificationsList" [ngClass]="{new: !notif?.isSeen}" (click)="notificationMenu = false">

                        </div>
                      </cdk-virtual-scroll-viewport> -->
                  <div *ngFor="let notif of notificationsList" [ngClass]="{new: !notif?.isSeen}"
                    (click)="notificationMenu = false">
                  </div>
                </div>
              </ng-container>
            </div>

          </div>
        </div>
      </div>
      <ng-container *ngIf="!currentUser">
        <a class="icon login" [routerLink]="['/login']">
          <span>{{'header.login' | translate}}</span>
        </a>
        <a class="icon register" [routerLink]="['/register']">
          <span>{{'header.Create a new account' | translate}}</span>
        </a>
      </ng-container>
      <ng-container *ngIf="currentUser">
        <div class="elementor-widget-container">
          <div *ngIf="currentUser" class="userAccount userAccount-light dropdown-container m-0" id="userAccountDrop"
            appDropDown>
            <div class="dropdown-toggler d-flex align-items-center">
              <div class="profile-image">
                <img *ngIf="currentUser.ImagePath" [src]="currentUser.ImagePath" (error)="currentUser.ImagePath = ''" />
                <span *ngIf="!currentUser.ImagePath" [innerHTML]="currentUser.FullName | shortName"></span>
              </div>
              <div class="user-name">
                <span class="mr-2"> <span>{{ 'general.Hello' | translate }}</span>, {{currentUser.FullName}}</span>
              </div>
            </div>

            <div class="custom-dropdown-menu dropdown-inner-menu">
              <ul>
                <li><a [routerLink]="['user-profile']">
                    <span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="13.5" height="18" viewBox="0 0 13.5 18">
                        <path id="ic_user"
                          d="M.75,18A.75.75,0,0,1,0,17.25a6.75,6.75,0,1,1,13.5,0,.75.75,0,0,1-.75.75ZM2.25,4.5A4.5,4.5,0,1,1,6.75,9,4.5,4.5,0,0,1,2.25,4.5Z"
                          fill="#8E8FA2" />
                      </svg>
                    </span>
                    {{ 'profile.accountManagement' | translate }}
                  </a>
                </li>
                <!-- <li *ngIf="currentUser.UserType != 'CONSUMER'">
                  <a [href]="appRedirectUrl + '?refreshToken=' + currentUser.EncodedRefreshToken">
                    <span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="19.013" height="18.999"
                        viewBox="0 0 19.013 18.999">
                        <path id="ic_change_account"
                          d="M4.125,5.25A2.625,2.625,0,1,0,1.5,2.625,2.628,2.628,0,0,0,4.125,5.25Zm9,7.5A3.375,3.375,0,1,0,9.749,9.375,3.379,3.379,0,0,0,13.124,12.749Zm-6.8,1.205a1.492,1.492,0,0,1-.01,2.1L4.665,17.769a.75.75,0,1,1-1.081-1.039l.942-.98H3a3,3,0,0,1-3-3V12a.75.75,0,0,1,1.5,0v.75a1.5,1.5,0,0,0,1.5,1.5H4.521l-.937-.98a.75.75,0,0,1,1.081-1.04l1.659,1.726Zm11.644,3.082a5.085,5.085,0,0,0-9.688,0A.75.75,0,0,0,9,18h8.25a.749.749,0,0,0,.719-.961ZM4.125,6A4.333,4.333,0,0,0,.047,8.736.751.751,0,0,0,.75,9.75H7.5a.751.751,0,0,0,.7-1.013A4.331,4.331,0,0,0,4.125,6Z"
                          transform="translate(0.508 0.5)" fill="#8e8fa2" stroke="rgba(0,0,0,0)" stroke-miterlimit="10"
                          stroke-width="1" />
                      </svg>
                    </span>
                    {{ 'general.viewMyAccountAsSystemUser' | translate }}
                  </a>
                </li> -->
                <li *ngIf="currentUser.UserType == 'CONSUMER'">
                  <a [routerLink]="['/complaints']">
                    <span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
                        <path id="ic_complaints"
                          d="M24816.188,7967h-12.33a1.8,1.8,0,0,1-1.809-1.79v-.245h-.24a1.8,1.8,0,0,1-1.811-1.789V7950.8a1.806,1.806,0,0,1,1.811-1.794h12.332a1.8,1.8,0,0,1,1.809,1.794v.239h.238a1.8,1.8,0,0,1,1.281.526,1.756,1.756,0,0,1,.529,1.264v12.387A1.8,1.8,0,0,1,24816.188,7967Zm-12.678-2.035h0v.245a.348.348,0,0,0,.348.347h12.33a.347.347,0,0,0,.348-.331v-12.4a.351.351,0,0,0-.348-.347h-.238v10.7a1.8,1.8,0,0,1-1.809,1.789Zm4.383-13.157a4.9,4.9,0,1,0,4.9,4.9A4.906,4.906,0,0,0,24807.893,7951.81Zm0,8.371a3.469,3.469,0,1,1,3.465-3.467A3.47,3.47,0,0,1,24807.893,7960.181Zm0-1.922a1.285,1.285,0,0,1,.912.383.718.718,0,0,0,1.016-1.015,2.725,2.725,0,0,0-3.854,0,.732.732,0,0,0-.209.51.7.7,0,0,0,.209.51.72.72,0,0,0,.5.209.73.73,0,0,0,.51-.209A1.285,1.285,0,0,1,24807.893,7958.258Zm1.783-3.293a.847.847,0,0,0-.605.25.872.872,0,0,0-.25.6.862.862,0,0,0,.25.607.836.836,0,0,0,.605.249.847.847,0,0,0,.607-.249.861.861,0,0,0,.248-.607.837.837,0,0,0-.254-.6A.851.851,0,0,0,24809.676,7954.965Zm-3.572,0a.857.857,0,0,0-.6.25.846.846,0,0,0,0,1.208.842.842,0,0,0,.6.249.853.853,0,0,0,.611-.249.863.863,0,0,0,.25-.607.86.86,0,0,0-.861-.852Z"
                          transform="translate(-24799.498 -7948.501)" fill="#8e8fa2" stroke="rgba(0,0,0,0)"
                          stroke-miterlimit="10" stroke-width="1" />
                      </svg>
                    </span>
                    {{ 'general.complaints' | translate }}
                  </a>
                </li>
                <li>
                  <a (click)="logout()">
                    <span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
                        <path id="ic_log_out"
                          d="M16173.752,16742a3.755,3.755,0,0,1-3.751-3.75v-10.5a3.755,3.755,0,0,1,3.751-3.75h1.5a.75.75,0,0,1,0,1.5h-1.5a2.251,2.251,0,0,0-2.251,2.25v10.5a2.251,2.251,0,0,0,2.251,2.25h1.5a.75.75,0,0,1,0,1.5Zm9.382-3.969a.75.75,0,0,1,.019-1.061l2.91-2.91a1.5,1.5,0,0,0,.25-.346.518.518,0,0,1-.059.012l-11.761.023a.75.75,0,0,1,0-1.5l11.766-.023c.011,0,.021.006.031.006a1.556,1.556,0,0,0-.225-.293l-2.91-2.908a.75.75,0,0,1,1.061-1.061l2.91,2.908h0a3,3,0,0,1,0,4.242l-2.91,2.91-.019.018a.75.75,0,0,1-1.061-.018Z"
                          transform="translate(-16169.501 -16723.502)" fill="#8e8fa2" stroke="rgba(0,0,0,0)"
                          stroke-miterlimit="10" stroke-width="1" />
                      </svg>
                    </span>
                    {{ 'general.logout' | translate }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </ng-container>
      <a class="icon language" (click)="changeLanguage()">
        <span>{{ 'general.language' | translate }}</span>
      </a>
    </div>
  </div>
</header>


<ng-template #notifContent let-notif="notif">
  <p class="title">{{notif?.text}}</p>
  <span class="date">
    {{notif?.date | timeAgo}}
  </span>
</ng-template>
